import "core-js";
import React from "react";

import { HelmetProvider } from "react-helmet-async";

import "./index.css";
import App from "./App";
import { ConsentTrackerLoaders } from "./Components/Consent/ConsentTrackerLoaders";
import { ConsentProvider } from "./context/ConsentContext";
import StateProvider from "./context/StateContext";
import reportWebVitals from "./reportWebVitals";

import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import { IconContext } from "react-icons";
import { BrowserRouter } from "react-router";
import { queryClient } from "./lib/api-client";

import "react-phone-number-input/style.css";

import "./utils/init";
import { registerPreloadErrorRecovery } from "./utils/chunk-reload";

import * as Sentry from "@sentry/react";
import { NuqsAdapter } from "nuqs/adapters/react-router/v8";
import { Button, Snippet } from "@heroui/react";
import { Trans } from "@lingui/react/macro";

registerPreloadErrorRecovery();

const container = document.getElementById("root") as HTMLDivElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <Sentry.ErrorBoundary
        fallback={({ error, componentStack, resetError }) => {
          const eventId = Sentry.lastEventId();

          return (
            <div className="flex h-screen flex-col items-center justify-center">
              <h2 style={{ color: "#333" }}>
                {" "}
                <Trans>Prišlo je do napake</Trans>
              </h2>
              <p style={{ color: "#666", marginBottom: "1rem" }}>
                <Trans>
                  Se opravčujemo za nevšečnost. Prosimo, osvežite stran.
                </Trans>
              </p>
              <Button onPress={() => window.location.reload()} color="primary">
                <Trans>Osveži stran</Trans>
              </Button>
              <div className="mt-4 text-sm text-gray-500">
                <Trans>
                  ID napake: <Snippet hideSymbol>{eventId}</Snippet>
                </Trans>
              </div>
            </div>
          );
        }}
      >
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            <ConsentProvider>
              <ConsentTrackerLoaders />
              <IconContext.Provider value={{ className: "icons" }}>
                <StateProvider>
                  <BrowserRouter>
                    <NuqsAdapter>
                      <App />
                    </NuqsAdapter>
                  </BrowserRouter>
                </StateProvider>
              </IconContext.Provider>
            </ConsentProvider>
          </QueryClientProvider>
        </HelmetProvider>
      </Sentry.ErrorBoundary>
    </I18nProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

declare global {
  interface Window {
    hsConversationsSettings: Record<string, any>;
    hsConversationsOnReady: Array<() => void>;
    HubSpotConversations: {
      on: any;
      off: any;
      widget: {
        status: () => { loaded: boolean; pending: boolean };
        load: (params?: { widgetOpen: boolean }) => void;
        remove: () => void;
        open: () => void;
        close: () => void;
        refresh: (openToNewThread?: boolean) => void;
      };
    };
  }
}
